<template>
  <div>
       <el-select v-model="value" placeholder="请选择" @change="handleChangeLang">
            <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value">
            </el-option>
        </el-select>
  </div>
</template>

<script>
export default {
    name:'ipLanguageSwitch',
    data(){
        return{
            value:'zh-CN',
            options:[{value:'zh-CN',label:'中文'},
            {value:'en-US',label:'英文'}]
        }
    },
    methods:{
        handleChangeLang(tag){
            console.log(tag);
            this.$i18n.locale=tag
        }
    }
}

</script>
<style lang="scss" scoped>
</style>